import { initOnlineMasteringPricing } from '../online-mastering-main/pricing';
import { initTooltips } from '../online-mastering-main/tooltips/tooltips-provider';

const handlePopup = () => {
    const params = new URLSearchParams(window.location.search);

    if(params.get('specs') !== '1') return;

    const $popup = document.getElementById('specs');
    if(!$popup) return;

    $popup.style.display = 'block';
};

const init = () => {
    initOnlineMasteringPricing();
    initTooltips();
    handlePopup();
};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};

